import {
	TeamMemberStatusType
} from "@teaming/common-enums";

export default {
	[ `memberStatusType_${ TeamMemberStatusType.ACTIVE }` ]: "Active",
	[ `memberStatusType_${ TeamMemberStatusType.INVITED }` ]: "Pending Invitation",
	[ `memberStatusType_${ TeamMemberStatusType.DEFERRED }` ]: "Deferred",
};
